"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nKey = exports.HS_ANCHOR_ATTRIBUTE = exports.TEMP_ANCHOR_ATTRIBUTE = exports.ANCHOR_CLASSNAME = void 0;

var _i18n = require("../utils/i18n");

var ANCHOR_CLASSNAME = 'mce-item-anchor'; // Built-in tinymce class

exports.ANCHOR_CLASSNAME = ANCHOR_CLASSNAME;
var TEMP_ANCHOR_ATTRIBUTE = 'data-insert-anchor';
exports.TEMP_ANCHOR_ATTRIBUTE = TEMP_ANCHOR_ATTRIBUTE;
var HS_ANCHOR_ATTRIBUTE = 'data-hs-anchor'; // Attribute that will persist through serialization

exports.HS_ANCHOR_ATTRIBUTE = HS_ANCHOR_ATTRIBUTE;
var i18nKey = (0, _i18n.i18nWithNameSpace)('TinymcePlugins.hsanchor');
exports.i18nKey = i18nKey;